import { z } from 'zod'
export const panSchema = z.object({ name: z.string(), productId: z.string().nullable(), startedAt: z.iso.datetime(), durationMinutes: z.number().positive() })
export const buffetStateSchema = z.object({ screenId: z.string(), pans: z.record(z.string(), panSchema) })
export function remainingSeconds(startedAt: string, durationMinutes: number, now: number) {
  return Math.ceil((Date.parse(startedAt) + durationMinutes * 60_000 - now) / 1000)
}
export function buffetTone(seconds: number, durationMinutes: number, orange: number, red: number) {
  if (seconds <= 0) return 'expired'
  const percent = (seconds / (durationMinutes * 60)) * 100
  return percent <= red ? 'red' : percent <= orange ? 'orange' : 'green'
}
